// FNP-1675: the business record only. The provisioning and infrastructure
// fields went with FNP-60's retirement; console-api drops them next, and AppSync
// refuses a query that selects a field the schema no longer has, so this set
// must shrink before the API does.
const APPLICATION_FIELDS = `
    id
    name
    description
    url
    logoUrl
    applicationCategory
    applicationStatus
    displayName
    tags { key value }
    created
    updated
`;

// FNP-913: token pagination. The API has always supported it
// (`listApplications(filter, limit, nextToken): ApplicationConnection` with
// `nextToken: String` — console-api applications.graphql:103-106, :209); this
// query simply never asked for it, so the whole catalog came back as one
// unpaginated page and `nextToken` was discarded by the service.
//
// Selecting nextToken is what makes useInfiniteQuery possible — without it
// getNextPageParam has nothing to return and the list can never page.
export const listApplications = `
   query listApplications($filter: ApplicationsFilterInput, $limit: Int, $nextToken: String) {
       listApplications(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              ${APPLICATION_FIELDS}
           }
           nextToken
       }
   }
`;

export const getApplication = `
   query getApplication($id:ID!) {
       getApplication(id:$id) {
           ${APPLICATION_FIELDS}
       }
}`;
